import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DatatableComponent from "helpers/DatatableComponent";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";
import {ListAlt, MenuOpen } from "@mui/icons-material";
import { errorToast } from "helpers/Notification";
import { getError } from "store/helpers/common_functions";
import BasicMenu from "helpers/menu";

const ExpandedRows = (props) => {
  const {
    permittedMenu,
    handleChange,
    menus,
    parent,
    handleDelete
  } = props;
  const [openAction, setOpenAction] = React.useState(false);
  const [code, setCode] = React.useState(0);
  const list = menus?.filter((item) => item?.parentId === parent?.menuId);

  return (
    <>
      {list?.map((row, key) => {
        const menuExist = permittedMenu?.find(
          (item) => item?.menuId === row?.menuId
        );

        // permittedMenu={parent?.subMenus}
        const actionList = menus?.filter((item) => item?.parentId === row?.menuId);

        return (
          <>
            <TableRow key={row.id}>
              <TableCell align="right" component="th" scope="row" colSpan={2}>
                <MenuOpen />
              </TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.create}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        create: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.read}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        read: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.update}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        update: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                {" "}
                <div className="text-bold">
                  <input
                    checked={menuExist?.delete}
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        delete: e.target.checked,
                        menuId: row?.id,
                      })
                    }
                  />
                </div>
              </TableCell>
              <TableCell>
                <BasicMenu
                  onDelete={() => handleDelete(row?.id)}
                  onDetails={() => {
                    setCode(row.code);
                    setOpenAction(true);
                  }}
                  detailsName="Actions"
                />
              </TableCell>
            </TableRow>
            {actionList?.map((action) => {
              const actionExist = menuExist?.actions?.find(
                (item) => item?.menuId === action?.menuId
              );
              return (
               
                        <TableRow key={action.code}
                        sx={{display: code === row.code && openAction?"table-row":"none"}}
                        >
                         <TableCell align="right" component="th" scope="row" colSpan={2}>
                            <ListAlt />
                          </TableCell>
                          <TableCell>{action.code}</TableCell>
                          <TableCell>{action.name}</TableCell>
                          <TableCell component="th" scope="row" colSpan={2} >{action.type}</TableCell>
                          <TableCell  component="th" scope="row" colSpan={3} >
                            {" "}
                            <div className="text-bold">
                              <input
                                checked={actionExist?.read}
                                type="checkbox"
                                disabled={!menuExist?.read}
                                onChange={(e) =>
                                  handleChange({
                                    read: e.target.checked,
                                    menuId: action?.id,
                                  })
                                }
                              />
                            </div>
                          </TableCell>
                          <TableCell >
                            <BasicMenu
                              onDelete={() => handleDelete(action?.id)}
                            />
                          </TableCell>
                        </TableRow>
              );
            })}
          </>
        );
      })}
    </>
  );
};

const PermissionList = (props) => {
  const { menus, location, PutAction ,category} = props;

  const userId = location.state?.userId;

  const [list, setList] = useState([]);
  const [change, setChange] = useState(0);
  const [permissions, setPermissions] = React.useState([]);
  const [foundMenus, setFoundMenus] = React.useState([]);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [open, setOpen] = React.useState(0);
  const [id, setId] = React.useState();
  const [deleteUrl, setDeleteActionUrl] = React.useState(null);

  useEffect(() => {
    const menuIds = list?.map((item) => item.menuId);

    const foundMenus = menus.filter(
      (item) => !menuIds?.includes(item?.menuId) && item?.Menu?.type === category
    );
    setFoundMenus(foundMenus);
  }, [change, list]);

  const reload = () => {
    setChange((v) => v + 1);
  };

  const handleDelete = (menuId) => {
    setDeleteOpen(1);
    setDeleteActionUrl(`/api/permission/user/${menuId}/${userId}`);
    setChange(change + 1);
  };

  const handleChange = async (changeData) => {
    const resp = await PutAction(
      `/api/permission/user/update/${userId}`,
      changeData
    );
    if (resp.status) {
      reload();
    } else {
      errorToast(getError(resp));
    }
  };

  const onCheck = (row) => {
    const arrayCopy = [...permissions];
    const index = arrayCopy.findIndex((perm) => perm?.menuId === row?.menuId);
    if (index !== -1) {
      arrayCopy[index] = row; // Replace a permission
    } else {
      arrayCopy.push(row);
    }
    setPermissions(arrayCopy);
  };

  const columns = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "Name",
      name: "name",
    },
    {
      label: "Type",
      name: "type",
    },
    {
      label: "Create",
      name: "create",
    },
    {
      label: "Read",
      name: "read",
    },
    {
      label: "Update",
      name: "update",
    },
    {
      label: "Delete",
      name: "delete",
    },
    {
      label: "Action",
      name: "menuId",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            onDelete={() => handleDelete(v)}
          />
        ),
      },
    },
  ];

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={reload}
        url={deleteUrl}
      />

      <FormDialog
        maxWidth={"md"}
        col={12}
        open={open > 0}
        onSuccess={() => {
          window.location.reload();
        }}
        setOpen={setOpen}
        url={
          open === 1
            ? `/api/permission/user/create/${userId}`
            : `/api/permission/user/update/${id}`
        }
        title={open === 1 ? `Assign new ${category}(s)` : "Edit Permission"}
        fields={[
          {
            label: "Permission List",
            name: "permissions",
            value: permissions,
            required: true,
            render: () => {
              return (
                <TableContainer className="border">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Type</TableCell>
                          <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {foundMenus?.length ? (
                        foundMenus?.map((row, index) => {
                          const selectedMenu =
                            permissions.find(
                              (perm) => perm?.menuId === row.id
                            ) ?? {};
                          const userMenu = {
                            menuId: selectedMenu.menuId ?? row.id,
                            create: selectedMenu.create ?? false,
                            read: selectedMenu.read ?? false,
                            update: selectedMenu.update ?? false,
                            delete: selectedMenu.delete ?? false,
                          };

                          return (
                            <TableRow>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row?.name}</TableCell>
                              <TableCell>{row?.Menu?.type}</TableCell>
                      
                              <TableCell>
                                <Checkbox
                                  checked={userMenu.read}
                                  onChange={(event) => {
                                    onCheck({
                                      ...userMenu,
                                      read: event.target.checked,
                                    });
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} className="text-center">
                            No permission selected
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              );
            },
          },
        ]}
      />
    
      <DatatableComponent
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columns}
        search={false}
        viewColumns={false}
        searchfield={true}
        url={`/api/structure/user/permission/dataTable?userId=${userId}&change=${change}&type=${category}`}
        title={
          <div className="w-full">
            <Typography variant="h6">User Permissions</Typography>
          </div>
        }
        onAddNew={() => {
          setOpen(1);
        }}

        expandableRows={category==="menu"}
        renderExpandableRow={(rowData, rowMeta) => {
          let index2 = rowMeta?.dataIndex;
          const parent = list[index2];
          return (
            <ExpandedRows
              permittedMenu={parent?.subMenus}
              menus={menus}
              parent={parent}
              index={index2}
              handleChange={handleChange}
              handleDelete={handleDelete}
            />
          );
        }}
      />
    </div>
  );
};

export default PermissionList;
